import React from 'react';
import { IEpNavHighlightActiveAttr } from '../../interfaces';
import { EpIcon } from '../EpIcon';

import './EpNavHighlight.scss';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      tagNameContent: unknown;
    }
  }
}

interface EpNavHighlightProps {
  navHighlightId: string;
  navHighlightSize?: 'sm' | 'md';
  navHighlightStatus?: 'active' | 'disabled';
  navHighlightActiveHref?: string;
  navHighlightActiveTarget?: '_blank' | '_self' | '_parent' | '_top';
  // eslint-disable-next-line @typescript-eslint/ban-types
  navHighlightDisabledOnClickFunc?: Function;
  navHighlightIconName: string;
  navHighlightTitle: string;
  customClasses?: string;
}

export const EpNavHighlight: React.FC<EpNavHighlightProps> = ({
  navHighlightId,
  navHighlightSize = 'md',
  navHighlightStatus = 'active',
  navHighlightActiveHref,
  navHighlightActiveTarget = '_blank',
  navHighlightDisabledOnClickFunc,
  navHighlightIconName,
  navHighlightTitle,
  customClasses,
}) => {
  const iconSize: number = navHighlightSize === 'sm' ? 24 : 32;
  const setNavHighlightActiveAtrr = (): IEpNavHighlightActiveAttr => {
    return {
      href: navHighlightActiveHref || '',
      target: navHighlightActiveTarget,
      rel: 'noopener noreferrer',
    };
  };

  return (
    <a
      id={navHighlightId}
      className={`
        ep-nav-highlight
        ep-nav-highlight--${navHighlightSize}
        ep-nav-highlight--${navHighlightStatus}
        ${customClasses ? customClasses : ''}
      `}
      {...(navHighlightStatus === 'active'
        ? setNavHighlightActiveAtrr()
        : {
          ...(navHighlightDisabledOnClickFunc && {
            onClick: () => navHighlightDisabledOnClickFunc(),
          }),
          role: 'button',
        })}
    >
      <div className="ep-nav-highlight__icon-wrapper">
        <EpIcon
          customClasses="ep-nav-highlight__icon"
          iconName={navHighlightIconName}
          iconSize={iconSize}
        ></EpIcon>
      </div>

      <h4 className="ep-nav-highlight__title">{navHighlightTitle}</h4>
    </a>
  );
};
